import { render } from "./Connect.vue?vue&type=template&id=318ab408&scoped=true"
import script from "./Connect.vue?vue&type=script&lang=js"
export * from "./Connect.vue?vue&type=script&lang=js"

import "./Connect.vue?vue&type=style&index=0&id=318ab408&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318ab408"]])

export default __exports__